function numberFormat(number) {
    return new Intl.NumberFormat('tr-TR', {
        maximumSignificantDigits: 4
    }).format(number)
}

function moneyFormat(number, currency = 'TRY') {
    return new Intl.NumberFormat('tr-TR', {
        style: 'currency',
        currency
    }).format(number)
}

export {
    moneyFormat,
    numberFormat
}